import type { IComponentController } from "angular";
import "angular-translate";

import type { IEventsGroup, IResponseWithLoading } from "App/Modules/Models";
import { EventType, EventTypeFunctions } from "App/Modules/Models";
import type { IEventsRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services";

export default class AlarmEventsComponentController implements IComponentController {
    public static $inject: string[] = ["$translate", "mmEventsRepository"];

    public caption: string;

    public events: IResponseWithLoading<IEventsGroup>;

    public siteId: string;

    public timeZone: string;

    public subCaption: string;

    constructor(
        private readonly $translate: angular.translate.ITranslateService,
        private readonly eventsRepository: IEventsRepository,
    ) {}

    public $onInit() {
        extendWithLoadingAndFail(this.eventsRepository.getEvents(this.siteId, null, null, null, 0, 15)).subscribe(
            (result) => {
                this.events = result;
                if (!this.events.data) {
                    return;
                }

                const subCaptionTypes: string[] = [];
                const typesWithCount = EventTypeFunctions.enhanceAlarmEventTypes(this.events.data.eventsTotal);
                // todo: Rewrite below lint exception for now /Victor 2020-03
                // eslint-disable-next-line no-restricted-syntax, @typescript-eslint/no-for-in-array
                for (const i in typesWithCount) {
                    if (typesWithCount[i].value > 0) {
                        const type = typesWithCount[i];
                        this.$translate(`Enums.EventType.${EventType[type.key]}`).then((translatedType) => {
                            const count = type.value;
                            subCaptionTypes.push(`${count} ${translatedType}`);
                            if (subCaptionTypes.length === Object.keys(typesWithCount).length) {
                                this.subCaption = subCaptionTypes.join(", ");
                            }
                        });
                    }
                }

                const total = this.events.data.eventsTotal.map((v) => v.value).reduce((a, b) => a + b, 0);
                this.$translate("Entities.AlarmEvent.EventsCountFormat", { eventsCount: total }, "messageformat").then(
                    (translation) => {
                        this.caption = translation;
                    },
                );
            },
            (error) => {
                this.events = error;
                this.caption = this.$translate.instant("Entities.AlarmEvent.NoAlarmDataAvailable");
            },
        );
    }
}
